import { defineAsyncComponent, DefineComponent } from 'vue'
import { IconName, IconType } from './types'

const iconComponents: Record<
  IconName,
  Partial<Record<IconType, DefineComponent<{}, {}, any>>>
> = {
  archive: {
    regular: defineAsyncComponent(() => import('./svgs/archive/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/archive/solid.svg'))
  },
  'arrow-alt-left': {
    regular: defineAsyncComponent(
      () => import('./svgs/arrow-alt-left/regular.svg')
    )
  },
  'arrow-alt-right': {
    regular: defineAsyncComponent(
      () => import('./svgs/arrow-alt-right/regular.svg')
    )
  },
  'arrow-alt-to-left': {
    regular: defineAsyncComponent(
      () => import('./svgs/arrow-alt-to-left/regular.svg')
    )
  },
  'arrow-alt-to-right': {
    regular: defineAsyncComponent(
      () => import('./svgs/arrow-alt-to-right/regular.svg')
    )
  },
  'arrows-h': {
    regular: defineAsyncComponent(() => import('./svgs/arrows-h/regular.svg'))
  },
  ban: {
    regular: defineAsyncComponent(() => import('./svgs/ban/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/ban/solid.svg'))
  },
  'bars-sort': {
    regular: defineAsyncComponent(() => import('./svgs/bars-sort/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/bars-sort/solid.svg'))
  },
  bell: {
    regular: defineAsyncComponent(() => import('./svgs/bell/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/bell/solid.svg'))
  },
  'bell-slash': {
    regular: defineAsyncComponent(
      () => import('./svgs/bell-slash/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/bell-slash/solid.svg'))
  },
  briefcase: {
    regular: defineAsyncComponent(() => import('./svgs/briefcase/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/briefcase/solid.svg'))
  },
  'calendar-alt': {
    regular: defineAsyncComponent(
      () => import('./svgs/calendar-alt/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/calendar-alt/solid.svg'))
  },
  'caret-down': {
    regular: defineAsyncComponent(
      () => import('./svgs/caret-down/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/caret-down/solid.svg'))
  },
  'caret-right': {
    regular: defineAsyncComponent(
      () => import('./svgs/caret-right/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/caret-right/solid.svg'))
  },
  check: {
    regular: defineAsyncComponent(() => import('./svgs/check/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/check/solid.svg'))
  },
  'check-circle': {
    regular: defineAsyncComponent(
      () => import('./svgs/check-circle/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/check-circle/solid.svg'))
  },
  'check-square': {
    regular: defineAsyncComponent(
      () => import('./svgs/check-square/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/check-square/solid.svg'))
  },
  'chevron-double-left': {
    regular: defineAsyncComponent(
      () => import('./svgs/chevron-double-left/regular.svg')
    )
  },
  'chevron-double-right': {
    regular: defineAsyncComponent(
      () => import('./svgs/chevron-double-right/regular.svg')
    )
  },
  'chevron-down': {
    regular: defineAsyncComponent(
      () => import('./svgs/chevron-down/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/chevron-down/solid.svg'))
  },
  'chevron-left': {
    regular: defineAsyncComponent(
      () => import('./svgs/chevron-left/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/chevron-left/solid.svg'))
  },
  'chevron-right': {
    regular: defineAsyncComponent(
      () => import('./svgs/chevron-right/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/chevron-right/solid.svg'))
  },
  'chevron-up': {
    regular: defineAsyncComponent(
      () => import('./svgs/chevron-up/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/chevron-up/solid.svg'))
  },
  circle: {
    regular: defineAsyncComponent(() => import('./svgs/circle/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/circle/solid.svg'))
  },
  'circle-user': {
    regular: defineAsyncComponent(
      () => import('./svgs/circle-user/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/circle-user/solid.svg'))
  },
  'clipboard-list': {
    regular: defineAsyncComponent(
      () => import('./svgs/clipboard-list/regular.svg')
    )
  },
  clock: {
    regular: defineAsyncComponent(() => import('./svgs/clock/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/clock/solid.svg'))
  },
  cog: {
    regular: defineAsyncComponent(() => import('./svgs/cog/regular.svg'))
  },
  columns: {
    regular: defineAsyncComponent(() => import('./svgs/columns/regular.svg'))
  },
  comment: {
    regular: defineAsyncComponent(() => import('./svgs/comment/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/comment/solid.svg'))
  },
  comments: {
    regular: defineAsyncComponent(() => import('./svgs/comments/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/comments/solid.svg'))
  },
  'compress-alt': {
    regular: defineAsyncComponent(
      () => import('./svgs/compress-alt/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/compress-alt/solid.svg'))
  },
  'convert-pdf': {
    regular: defineAsyncComponent(
      () => import('./svgs/convert-pdf/regular.svg')
    )
  },
  'dollar-sign': {
    regular: defineAsyncComponent(
      () => import('./svgs/dollar-sign/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/dollar-sign/solid.svg'))
  },
  download: {
    regular: defineAsyncComponent(() => import('./svgs/download/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/download/solid.svg'))
  },
  edit: {
    regular: defineAsyncComponent(() => import('./svgs/edit/regular.svg'))
  },
  'ellipsis-h': {
    regular: defineAsyncComponent(
      () => import('./svgs/ellipsis-h/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/ellipsis-h/solid.svg'))
  },
  'ellipsis-v': {
    regular: defineAsyncComponent(
      () => import('./svgs/ellipsis-v/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/ellipsis-v/solid.svg'))
  },
  envelope: {
    regular: defineAsyncComponent(() => import('./svgs/envelope/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/envelope/solid.svg'))
  },
  'envelope-open': {
    regular: defineAsyncComponent(
      () => import('./svgs/envelope-open/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/envelope-open/solid.svg'))
  },
  'exclamation-circle': {
    regular: defineAsyncComponent(
      () => import('./svgs/exclamation-circle/regular.svg')
    )
  },
  'exclamation-triangle': {
    regular: defineAsyncComponent(
      () => import('./svgs/exclamation-triangle/regular.svg')
    ),
    solid: defineAsyncComponent(
      () => import('./svgs/exclamation-triangle/solid.svg')
    )
  },
  'expand-arrows': {
    regular: defineAsyncComponent(
      () => import('./svgs/expand-arrows/regular.svg')
    )
  },
  'external-link-alt': {
    regular: defineAsyncComponent(
      () => import('./svgs/external-link-alt/regular.svg')
    ),
    solid: defineAsyncComponent(
      () => import('./svgs/external-link-alt/solid.svg')
    )
  },
  eye: {
    regular: defineAsyncComponent(() => import('./svgs/eye/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/eye/solid.svg'))
  },
  'eye-slash': {
    regular: defineAsyncComponent(() => import('./svgs/eye-slash/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/eye-slash/solid.svg'))
  },
  file: {
    regular: defineAsyncComponent(() => import('./svgs/file/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/file/solid.svg'))
  },
  'file-alt': {
    regular: defineAsyncComponent(() => import('./svgs/file-alt/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/file-alt/solid.svg'))
  },
  'file-archive': {
    regular: defineAsyncComponent(
      () => import('./svgs/file-archive/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/file-archive/solid.svg'))
  },
  'file-export': {
    regular: defineAsyncComponent(
      () => import('./svgs/file-export/regular.svg')
    )
  },
  filter: {
    regular: defineAsyncComponent(() => import('./svgs/filter/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/filter/solid.svg'))
  },
  flag: {
    regular: defineAsyncComponent(() => import('./svgs/flag/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/flag/solid.svg'))
  },
  flask: {
    regular: defineAsyncComponent(() => import('./svgs/flask/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/flask/solid.svg'))
  },
  folder: {
    regular: defineAsyncComponent(() => import('./svgs/folder/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/folder/solid.svg'))
  },
  'folder-open': {
    regular: defineAsyncComponent(
      () => import('./svgs/folder-open/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/folder-open/solid.svg'))
  },
  'folder-tree': {
    regular: defineAsyncComponent(
      () => import('./svgs/folder-tree/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/folder-tree/solid.svg'))
  },
  frown: {
    regular: defineAsyncComponent(() => import('./svgs/frown/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/frown/solid.svg'))
  },
  'hand-paper': {
    regular: defineAsyncComponent(() => import('./svgs/hand-paper/regular.svg'))
  },
  'hand-point-right': {
    regular: defineAsyncComponent(
      () => import('./svgs/hand-point-right/regular.svg')
    ),
    solid: defineAsyncComponent(
      () => import('./svgs/hand-point-right/solid.svg')
    )
  },
  highlighter: {
    regular: defineAsyncComponent(
      () => import('./svgs/highlighter/regular.svg')
    )
  },
  history: {
    regular: defineAsyncComponent(() => import('./svgs/history/regular.svg'))
  },
  'hourglass-start': {
    regular: defineAsyncComponent(
      () => import('./svgs/hourglass-start/regular.svg')
    ),
    solid: defineAsyncComponent(
      () => import('./svgs/hourglass-start/solid.svg')
    )
  },
  'i-cursor': {
    regular: defineAsyncComponent(() => import('./svgs/i-cursor/regular.svg'))
  },
  'inbox-out': {
    regular: defineAsyncComponent(() => import('./svgs/inbox-out/regular.svg'))
  },
  info: {
    regular: defineAsyncComponent(() => import('./svgs/info/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/info/solid.svg'))
  },
  'info-circle': {
    regular: defineAsyncComponent(
      () => import('./svgs/info-circle/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/info-circle/solid.svg'))
  },
  'level-up': {
    regular: defineAsyncComponent(() => import('./svgs/level-up/regular.svg'))
  },
  link: {
    regular: defineAsyncComponent(() => import('./svgs/link/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/link/solid.svg'))
  },
  'list-alt': {
    regular: defineAsyncComponent(() => import('./svgs/list-alt/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/list-alt/solid.svg'))
  },
  listui: {
    regular: defineAsyncComponent(() => import('./svgs/listui/regular.svg'))
  },
  lock: {
    regular: defineAsyncComponent(() => import('./svgs/lock/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/lock/solid.svg'))
  },
  'lock-open': {
    regular: defineAsyncComponent(() => import('./svgs/lock-open/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/lock-open/solid.svg'))
  },
  'mapmarker-alt': {
    regular: defineAsyncComponent(
      () => import('./svgs/mapmarker-alt/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/mapmarker-alt/solid.svg'))
  },
  menu: {
    regular: defineAsyncComponent(() => import('./svgs/menu/regular.svg'))
  },
  minus: {
    regular: defineAsyncComponent(() => import('./svgs/minus/regular.svg'))
  },
  'minus-circle': {
    regular: defineAsyncComponent(
      () => import('./svgs/minus-circle/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/minus-circle/solid.svg'))
  },
  'multi-folder': {
    regular: defineAsyncComponent(
      () => import('./svgs/multi-folder/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/multi-folder/solid.svg'))
  },
  'multi-folder-open': {
    regular: defineAsyncComponent(
      () => import('./svgs/multi-folder-open/regular.svg')
    ),
    solid: defineAsyncComponent(
      () => import('./svgs/multi-folder-open/solid.svg')
    )
  },
  ocr: {
    regular: defineAsyncComponent(() => import('./svgs/ocr/regular.svg'))
  },
  paperclip: {
    regular: defineAsyncComponent(() => import('./svgs/paperclip/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/paperclip/solid.svg'))
  },
  pause: {
    regular: defineAsyncComponent(() => import('./svgs/pause/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/pause/solid.svg'))
  },
  'pause-circle': {
    regular: defineAsyncComponent(
      () => import('./svgs/pause-circle/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/pause-circle/solid.svg'))
  },
  'pencil-alt': {
    regular: defineAsyncComponent(
      () => import('./svgs/pencil-alt/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/pencil-alt/solid.svg'))
  },
  phone: {
    regular: defineAsyncComponent(() => import('./svgs/phone/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/phone/solid.svg'))
  },
  play: {
    regular: defineAsyncComponent(() => import('./svgs/play/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/play/solid.svg'))
  },
  'play-circle': {
    regular: defineAsyncComponent(
      () => import('./svgs/play-circle/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/play-circle/solid.svg'))
  },
  plus: {
    regular: defineAsyncComponent(() => import('./svgs/plus/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/plus/solid.svg'))
  },
  print: {
    regular: defineAsyncComponent(() => import('./svgs/print/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/print/solid.svg'))
  },
  redo: {
    regular: defineAsyncComponent(() => import('./svgs/redo/regular.svg'))
  },
  save: {
    regular: defineAsyncComponent(() => import('./svgs/save/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/save/solid.svg'))
  },
  search: {
    regular: defineAsyncComponent(() => import('./svgs/search/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/search/solid.svg'))
  },
  'search-plus': {
    regular: defineAsyncComponent(
      () => import('./svgs/search-plus/regular.svg')
    )
  },
  'share-square': {
    regular: defineAsyncComponent(
      () => import('./svgs/share-square/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/share-square/solid.svg'))
  },
  sitemap: {
    regular: defineAsyncComponent(() => import('./svgs/sitemap/regular.svg'))
  },
  sort: {
    regular: defineAsyncComponent(() => import('./svgs/sort/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/sort/solid.svg'))
  },
  'sort-down': {
    regular: defineAsyncComponent(() => import('./svgs/sort-down/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/sort-down/solid.svg'))
  },
  'sort-up': {
    regular: defineAsyncComponent(() => import('./svgs/sort-up/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/sort-up/solid.svg'))
  },
  spinner: {
    regular: defineAsyncComponent(() => import('./svgs/spinner/regular.svg'))
  },
  square: {
    regular: defineAsyncComponent(() => import('./svgs/square/regular.svg'))
  },
  star: {
    regular: defineAsyncComponent(() => import('./svgs/star/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/star/solid.svg'))
  },
  'sub-folder': {
    regular: defineAsyncComponent(() => import('./svgs/sub-folder/regular.svg'))
  },
  sync: {
    regular: defineAsyncComponent(() => import('./svgs/sync/regular.svg'))
  },
  'tachometer-alt': {
    regular: defineAsyncComponent(
      () => import('./svgs/tachometer-alt/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/tachometer-alt/solid.svg'))
  },
  tag: {
    regular: defineAsyncComponent(() => import('./svgs/tag/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/tag/solid.svg'))
  },
  tags: {
    regular: defineAsyncComponent(() => import('./svgs/tags/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/tags/solid.svg'))
  },
  tasks: {
    regular: defineAsyncComponent(() => import('./svgs/tasks/regular.svg'))
  },
  'text-slash': {
    regular: defineAsyncComponent(
      () => import('./svgs/text-slash/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/text-slash/solid.svg'))
  },
  'th-large': {
    regular: defineAsyncComponent(() => import('./svgs/th-large/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/th-large/solid.svg'))
  },
  Thumbtack: {
    regular: defineAsyncComponent(() => import('./svgs/Thumbtack/regular.svg'))
  },
  times: {
    regular: defineAsyncComponent(() => import('./svgs/times/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/times/solid.svg'))
  },
  'times-circle': {
    regular: defineAsyncComponent(
      () => import('./svgs/times-circle/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/times-circle/solid.svg'))
  },
  tools: {
    regular: defineAsyncComponent(() => import('./svgs/tools/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/tools/solid.svg'))
  },
  'trash-alt': {
    regular: defineAsyncComponent(() => import('./svgs/trash-alt/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/trash-alt/solid.svg'))
  },
  university: {
    regular: defineAsyncComponent(
      () => import('./svgs/university/regular.svg')
    ),
    solid: defineAsyncComponent(() => import('./svgs/university/solid.svg'))
  },
  upload: {
    regular: defineAsyncComponent(() => import('./svgs/upload/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/upload/solid.svg'))
  },
  user: {
    regular: defineAsyncComponent(() => import('./svgs/user/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/user/solid.svg'))
  },
  users: {
    regular: defineAsyncComponent(() => import('./svgs/users/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/users/solid.svg'))
  },
  wrench: {
    regular: defineAsyncComponent(() => import('./svgs/wrench/regular.svg')),
    solid: defineAsyncComponent(() => import('./svgs/wrench/solid.svg'))
  }
}

export function getIcon(
  name: IconName,
  type: IconType
): DefineComponent<{}, {}, any> {
  const iconSet = iconComponents[name]
  const component = iconSet?.[type]

  if (component) {
    return component
  }

  console.warn(
    `Icon "${name}-${type}" not found, falling back to archive-regular`
  )
  return iconComponents.archive.regular!
}

export { iconComponents }
